import { render, staticRenderFns } from "./CorporatesSelector.vue?vue&type=template&id=763a436d&scoped=true&"
import script from "./CorporatesSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./CorporatesSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a436d",
  null
  
)

export default component.exports